export const GET_CARDHOLDER_INFO = 'get_cardholder_info';
export const RESET_CARDHOLDER_INFO = 'reset_cardholder_info';
export const SET_LAST_SECTION_VISITED = 'set_last_section_visited';
export const RESET_LAST_SECTION_VISITED = 'reset_last_section_visited';
